import * as animateScroll from "svelte-scrollto";
import { map } from "rambda";
import { writable } from "svelte/store";

import { sineIn } from "svelte/easing";

const scrollDuration = 750;

const scrollTo = (element) =>
  animateScroll.scrollTo({
    element,
    duration: scrollDuration,
    easing: sineIn,
  });

const scrollToTop = () =>
  animateScroll.scrollToTop({ duration: scrollDuration, easing: sineIn });

function createNavigationStore() {
  const { subscribe, update } = writable({
    home: true,
    about: false,
    benefits: false,
    features: false,
    contacts: false,
  });

  const setInactive = (_) => false;

  return {
    subscribe,
    scrollTo,
    scrollToTop,
    changeActiveItem: (item) => {
      update((currentItems) => ({
        ...map(setInactive, currentItems),
        [item]: true,
      }));
    },
  };
}

export const navigationStore = createNavigationStore();
